import { Col, Row, Space, Typography } from "antd";
import { useCallback, useEffect } from "react";
import { useGetQuery } from "../../service/query/Queries";
import { useTranslation } from "react-i18next";
import { ThemesCard } from "../../components";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Random = () => {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();

    const {
        data: getRandom,
        refetch: refetchGetRandom,
        isLoading: isLoadingGetRandom,
        isSuccess: isSuccessGetRandom,
    } = useGetQuery(false, "get-random", `/theme/exams`, false);

    const editHandle = useCallback((id = 5) => navigate(`/random/test?editId=${id}`), [navigate]);

    useEffect(() => {
        refetchGetRandom();
    }, [i18n.language]);

    return (
        <div className="site-space-compact-wrapper">
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Row gutter={[10, 20]} align="middle">
                    <Col xs={24} md={12}>
                        <Title className="page--title" level={1} style={{ textAlign: "left" }}>
                            {t("random")}
                        </Title>
                    </Col>
                </Row>

                {isLoadingGetRandom && (
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                        <p>{t("loading")}...</p>
                    </div>
                )}

                <Row gutter={[16, 16]}>
                    {isSuccessGetRandom &&
                        getRandom.map((item) => (
                            <Col
                                key={item.id}
                                xs={24}
                                sm={12}
                                md={8}
                                className="gutter-row"
                                style={{ marginTop: 10 }}
                            >
                                <ThemesCard item={item} editHandle={editHandle} />
                            </Col>
                        ))}

                    {isSuccessGetRandom && getRandom?.length === 0 && (
                        <Col span={24} style={{ textAlign: "center", marginTop: 20 }}>
                            <p>{t("not_found")}</p>
                        </Col>
                    )}
                </Row>
            </Space>
        </div>
    );
};

export default Random;
